import ProductState from '../interfaces/states/ProductState';

import * as Const from '../constants';

const initState: ProductState = {
  productById: {
    0: { id: 0, name: 'agro', label: 'Agro' },
    1: { id: 1, name: 'lv', label: 'LandViewer' },
  },
  productOrder: [0, 1],
  currentProductId: 0,
};

export default function paymentsInfo (state: ProductState = initState, action): ProductState {
  switch (action.type) {

    case Const.PRODUCT_INIT:
      return {
        ...initState,
      };

    case Const.PRODUCT_RECEIVE:
      return {
        ...state,
        currentProductId: action.payload,
      };

    default:
      return state;
  }
}
